module.exports = __webpack_public_path__ + "img/arw-link-tertiary.c5bbffa0.svg";